import * as React from "react";

import {
  FeatureController,
  FeaturesProvider,
  OneTimePasswordFeatures,
  useOneTimePasswordFeatureController,
} from "../../../Common";

import { useReactPdpInitialState } from "../react-pdp-initial-state-provider";

export const ReactPdpFeatures = OneTimePasswordFeatures;

export const ReactPdpFeaturesProvider: React.FunctionComponent = (props) => {
  const { initialState } = useReactPdpInitialState();

  const oneTimePasswordFeatureController = useOneTimePasswordFeatureController({
    initialState,
  });

  const features: FeatureController[] = React.useMemo(
    () => [oneTimePasswordFeatureController],
    [oneTimePasswordFeatureController]
  );

  return (
    <FeaturesProvider features={features}>
      {props.children || []}
    </FeaturesProvider>
  );
};
